import { Outlet } from 'react-router-dom';
import Nav from './Nav';
import Footer from './Footer';
import EditorEnVivo from './EditorEnVivo';

export default function Layout() {
  return (
    <div className="app">
      <Nav />
      <Outlet />
      <Footer />
      <EditorEnVivo />
    </div>
  );
}
